import fetch from './fetch';
import { OfferApi } from './offer.types';

export const getOffers = (payload): OfferApi => {
  if (payload.offersPromo) {
    return fetch('GET', `/offers?promo=${payload.offersPromo}`);
  }
  return fetch('GET', '/offers');
};
